import { Component } from '@angular/core';

@Component({
  selector: 'ciag',
  templateUrl: './ciag.component.html',
  styleUrls: ['./ciag.component.scss']
})
export class CiagComponent {
  constructor() { }
}
